/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable arrow-body-style */

import React, { useState, useRef } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import {
    array,
    func,
    number,
    object, string, bool,
} from 'prop-types';
import { useHistory } from 'react-router-dom';
import FilterMenuBarItem from './FilterMenuBarItem';
import useCheckedFacets from '../../../../../../helpers/hooks/useCheckedFacets';
import ProductCount from '../../ProductCount/ProductCount';

const styles = (theme) => ({
    sortAndFilterContainer: {
        position: 'relative',
        margin: '10px 0 10px 0',
    },
    filterBtn: {
        whiteSpace: 'nowrap',
        border: `1px solid ${theme.palette.grey9}`,
        padding: '8px 0px 8px 8px',
        display: 'inline-block',
        cursor: 'pointer',
        color: theme.palette.colorPrimary,
        background: theme.palette.colorNeutral20,
        fontWeight: '700',
        fontSize: '14px',
    },
    filterContainerDialog: {
        zIndex: 1,
    },
    filterTitle: {
        color: theme.palette.colorNeutral70,
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '20px',
        margin: '16px 0',
    },
    chipsMainWrapper: {
        display: 'none',
    },
    filterOptions: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1pt solid #e6e6e6',
        borderBottom: '1pt solid #e6e6e6',
        '& button': {
            textTransform: 'capitalize',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    },
    filterSerachBtn: {
        padding: '13px 25px',
        borderRadius: '0px',
        color: theme.palette.colorNeutral70,
        fontWeight: 700,
        textTransform: 'capitalize',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            background: theme.palette.colorPrimary,
            color: theme.palette.colorPrimaryContrast,
        },
        '&:active': {
            background: theme.palette.colorPrimary,
            color: theme.palette.colorPrimaryContrast,
        },
        [theme.breakpoints.down('sm')]: {
            padding: '8px 10px',
        },
    },
    textRight: {
        textAlign: 'right',
    },
    content: {
        padding: '15px 0px',
        fontSize: '14px',
        fontWeight: 700,
        color: theme.palette.colorNeutral70,
    },
    applyBtn: {
        color: theme.palette.colorPrimary,
        width: '100%',
        border: '2px solid',
        display: 'block',
        padding: '8px 0px',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 700,
        cursor: 'pointer',
    },
    btnBackground: {
        background: theme.palette.colorPrimary,
        color: theme.palette.colorPrimaryContrast,
        '&:hover': {
            background: theme.palette.colorPrimary,
            color: theme.palette.colorPrimaryContrast,
        },
    },
    applyButtonWrapper: {
        marginTop: '10px',
    },
    switch: {
        '& span': {
            '& span': {
                color: theme.palette.colorPrimary,
            },
        },
    },
    ArrowDropdownIcon: {
        color: theme.palette.colorPrimary,
        marginTop: '-8px',
        marginBottom: '-8px',
        marginLeft: '-8px',
    },
});

const PlantsDesktopFilterDialog = ({
    classes,
    productFacets,
    setFacetsOptions,
    facetsData,
    setFilterOptions,
    setFacetsDataInCollection,
    brand,
    totalCount,
    ssrDeviceType,
    forPlantGuide,
}) => {
    const history = useHistory();
    const checkedFacetsData = useCheckedFacets();
    const [checkedOptions, setCheckedOptions] = useState(checkedFacetsData);
    const containerRef = useRef();

    const selectionChanged = (data) => {
        setCheckedOptions(data);
    };

    const resetChecked = () => {
        history.push({
            search: '',
        });
        setCheckedOptions([]);
        setFacetsDataInCollection([]);
    };

    const defaultMenuItem = [
        'Best Sellers',
        /* 'A to Z',
        'Z to A', */
        'Price: Low to High',
        'Price: High to Low',
    ];

    const getProductFacetsUI = () => {
        let productFacetsUI;
        if (productFacets?.length) {
            productFacetsUI = productFacets?.map((item) => {
                return (
                    <FilterMenuBarItem title={item?.name} filterOption={item?.entries} brand={brand} checkedOptions={checkedOptions} setCheckedOptions={selectionChanged} resetChecked={resetChecked} setFilterOptions={setFilterOptions} setFacetsOptions={setFacetsOptions} facetsData={facetsData} />
                );
            });
        }
        return productFacetsUI;
    };

    return (
        <div
            ref={containerRef}
            className={classes.sortAndFilterContainer}
        >
            <Grid container className={classes.filterContainerDialog}>
                <Grid item xs={12}>
                    <div className={classes.filterOptions}>
                        {!forPlantGuide && <FilterMenuBarItem title="Sort" filterOption={defaultMenuItem} brand={brand} checkedOptions={checkedOptions} setCheckedOptions={selectionChanged} setFacetsOptions={setFacetsOptions} facetsData={facetsData} setFilterOptions={setFilterOptions} totalCount={totalCount} />}
                        { getProductFacetsUI() }
                        {!forPlantGuide && <ProductCount totalCount={totalCount} ssrDeviceType={ssrDeviceType} brand={brand} />}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

PlantsDesktopFilterDialog.propTypes = {
    classes: object.isRequired,
    brand: string.isRequired,
    productFacets: array.isRequired,
    setFacetsOptions: array.isRequired,
    setFilterOptions: func.isRequired,
    setFacetsDataInCollection: array.isRequired,
    totalCount: number.isRequired,
    ssrDeviceType: string.isRequired,
    facetsData: array.isRequired,
    forPlantGuide: bool,
};

PlantsDesktopFilterDialog.defaultProps = {
    forPlantGuide: false,
};

export default (withStyles(styles)(PlantsDesktopFilterDialog));
